// Authentication mixin to handle token expiration and authentication errors
import { FORCE_LOGOUT } from "@/core/services/store/auth.module";

export const authMixin = {
  methods: {
    // Handle authentication errors in API calls
    handleAuthError(error) {
      if (error.response && error.response.status === 401) {
        this.$store.dispatch(FORCE_LOGOUT).then(({ message }) => {
          this.$bvToast.toast(message, {
            title: "Session Expired",
            variant: "warning",
            solid: true,
            autoHideDelay: 5000,
          });
        });
        // Redirect to login will be handled by axios interceptor
        return true; // Indicates auth error was handled
      }
      return false; // Not an auth error, let caller handle it
    },

    // Wrapper for axios calls with automatic auth error handling
    async apiCall(apiPromise, options = {}) {
      const {
        showSuccessToast = false,
        successMessage = "Operation successful",
      } = options;

      try {
        const result = await apiPromise;

        if (showSuccessToast) {
          this.$bvToast.toast(successMessage, {
            title: "Success",
            variant: "success",
            solid: true,
            autoHideDelay: 3000,
          });
        }

        return result.data;
      } catch (error) {
        // Check if it's an authentication error
        if (this.handleAuthError(error)) {
          return null; // Auth error handled, return null
        }

        // Re-throw the error for the caller to handle
        throw error;
      }
    },
  },
};

export default authMixin;
